import { css } from '@emotion/react';
import styled from '@emotion/styled';
/**
 * Custom product name style css declaration to be reused where wrapper
 * wont fit.
 */
export const CustomProductNameStyle = css `
  font-family: var(--product-name-font-family, inherit);
  color: var(--product-name-font-color, inherit);
`;
/**
 * Custom product name style wrapper base component to be used to wrap
 * any price so the custom css vars will kick in.
 */
export const CustomProductNameStyleWrapper = styled.span `
  ${CustomProductNameStyle}
`;
